class MovingTextBanner {
  constructor() {
    this.init();
  }

  init() {
    const banners = document.querySelectorAll('.moving-text-content');
    
    banners.forEach(banner => {
      const speed = banner.dataset.speed || 3;
      const duration = 180 / speed; // Base duration divided by speed (much slower now)
      
      banner.style.animationDuration = `${duration}s`;
      banner.style.animationPlayState = 'running';
      
      // Ensure smooth animation by forcing a reflow
      void banner.offsetWidth;
    });
  }
}

// Initialize immediately and on DOM load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MovingTextBanner();
  });
} else {
  new MovingTextBanner();
}

// Re-initialize for dynamic content (like theme editor)
document.addEventListener('shopify:section:load', () => {
  new MovingTextBanner();
}); 